import { useQuery, useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getReviews, submitReview } from "../api/reviews";
import type { ReviewSubmission } from "../api/reviews";
import { getActiveLang } from "../i18n";

export const reviewsQueryKey = (lang: string) => ["reviews", lang] as const;

export function useReviewsQuery() {
  // Subscribe to react-i18next so the hook re-renders on language change.
  useTranslation();
  const lang = getActiveLang();
  return useQuery({
    queryKey: reviewsQueryKey(lang),
    queryFn: () => getReviews(lang),
  });
}

export function useSubmitReviewMutation() {
  return useMutation({
    mutationFn: (input: ReviewSubmission) => submitReview(input),
  });
}
